 

export default class MedicalLink {

    Id: string | undefined;
    OperationAreaId: number | undefined;
    OperationAreaValue: string | undefined;
    NrRCE: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new MedicalLink();
    }
}